// extracted by mini-css-extract-plugin
module.exports = {"Contest":"Contest_Contest__1BBWD"};